import { useEffect } from "react";

// styles
import "./styles.scss";

const ActionBar = ({ children }) => {

    useEffect(() => {
        document.body.classList.add('has-action-bar-visible');

        return () => {
            document.body.classList.remove('has-action-bar-visible');
        }
    }, []);

    return (
        <nav className="navbar is-light is-fixed-bottom">
            <div className="navbar-end">
                <div className="navbar-item">
                    <div className="buttons">
                        {children}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export { ActionBar };
